module.exports = __webpack_public_path__ + "img/curved-rail-vertical-left-bottom-ties.77b678bb.png";